import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center h-screen"
}
const _hoisted_2 = {
  key: 1,
  id: "wrapper"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "tooltip" }, null, -1)

import "video.js/dist/video-js.css";
import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import ConfirmationModal from "shared/components/modals/ConfirmationModal.vue";
import SessionExpired from "shared/components/other/SessionExpired.vue";
import { useSaveReturnUrl } from "shared/composables/auth";
import logger from "shared/services/logger";
import "@/assets/styles/custom.css";
import { useRefreshSession } from "@/composables/auth";
import DashboardPreloader from "@/views/dashboard/components/DashboardPreloader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const authResolved = ref(false);
const dashboardPreloaded = ref(false);
const shouldPreloadDashboard = ref(false);

const router = useRouter();
const route = useRoute();
const store = useStore();

const refreshSession = useRefreshSession();
const saveReturnUrl = useSaveReturnUrl();

const isLoading = computed(() => !authResolved.value || !dashboardPreloaded.value);

onMounted(async () => {
  let session: unknown | undefined = undefined;
  try {
    session = await refreshSession();
  } catch (error) {
    logger.error("Unable to refresh session", error as Error);
  } finally {
    await router.isReady();
    shouldPreloadDashboard.value = !!session && route.name === "ProjectOverview";
    dashboardPreloaded.value = !shouldPreloadDashboard.value;
    if (!session) {
      if (route.meta.requireLogin) {
        saveReturnUrl();

        router.replace("/log-in");
      }
    }
    setTimeout(() => {
      authResolved.value = true;
    }, 0);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value && !_unref(store).state.isSessionExpired)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LoadingSpinner)
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value && !_unref(store).state.isSessionExpired)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_component_router_view, {
            key: _unref(route).path
          }))
        ]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmationModal),
    (_unref(store).state.isSessionExpired)
      ? (_openBlock(), _createBlock(SessionExpired, { key: 2 }))
      : _createCommentVNode("", true),
    _hoisted_3,
    (authResolved.value && shouldPreloadDashboard.value)
      ? (_openBlock(), _createBlock(DashboardPreloader, {
          key: 3,
          onReady: _cache[0] || (_cache[0] = ($event: any) => (dashboardPreloaded.value = true))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})